<app-page-container class="survey" [layoutType]="LayoutType.IntegratedTab" [tabConfig]="tabConfig" [title]="title"
  [breadcrumbProps]="breadcrumbProps">
</app-page-container>
